let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9tV1K")).then(() => parcelRequire('7gle3'));